export default __webpack_public_path__ + "static/media/user_saved.eccf4e69.png";